
export const MOTION_EXIT_MS = 100;
export const MOTION_EXIT_REDUCED_MS = 20;

const EXIT_HOLD_SLACK_MS = 32;

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function exitDurationMs(): number {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return MOTION_EXIT_MS;
  return window.matchMedia(REDUCED_MOTION_QUERY).matches ? MOTION_EXIT_REDUCED_MS : MOTION_EXIT_MS;
}

export function holdUntilExitEnds(release: () => void): () => void {
  let timer = 0;
  const frame = requestAnimationFrame(() => {
    timer = window.setTimeout(release, exitDurationMs() + EXIT_HOLD_SLACK_MS);
  });
  return () => {
    cancelAnimationFrame(frame);
    window.clearTimeout(timer);
  };
}
